// extracted by mini-css-extract-plugin
module.exports = {"progressContainer":"styles_progressContainer__qvUV8","gaugeContainer":"styles_gaugeContainer__1N3Td","text":"styles_text__3pcjF","percentageText":"styles_percentageText__lOHWt"};